import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25 24",
    fill: "currentColor",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M12.602 20.17a7.893 7.893 0 1 0 0-15.787 7.893 7.893 0 0 0 0 15.787m9.02-7.894a9.02 9.02 0 1 1-18.041 0 9.02 9.02 0 0 1 18.041 0"/> <path fill-rule="evenodd" clip-rule="evenodd" d="M16.402 9.586c.21.23.194.586-.036.796l-5.218 4.77-2.296-1.947a.564.564 0 1 1 .73-.86l1.538 1.305 4.485-4.1a.564.564 0 0 1 .797.036"/>' }
  })
);